<template>
  <div class="mx-5">
    <tabs
      @cur-part-id="handleCurPartId"
      @cur-category-id="handleCurCategoryId"
    />

    <div>
      <LoadingSpinner 
        v-if="isLoading" 
        text="Loading topics..."
      />
      <TopicManagerList v-else :partId="curPartId" :categoryId="curCategoryId" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect, onMounted } from "vue";
import tabs from "@/components/speaking/TopicTabs.vue";
// import topicCard from "~/components/admin/TopicCardManager.vue";
import TopicManagerList from "@/components/speaking/TopicManagerList.vue";
import LoadingSpinner from "@/components/ui/LoadingSpinner.vue";

const curPartId = ref(1);
const curCategoryId = ref(0);
const isManagingTopic = ref(false);
const isLoading = ref(true);

const handleCurPartId = (id: number) => {
  isLoading.value = true;
  curPartId.value = id;
  setTimeout(() => {
    isLoading.value = false;
  }, 500);
};

const handleCurCategoryId = (id: number) => {
  isLoading.value = true;
  curCategoryId.value = id;
  setTimeout(() => {
    isLoading.value = false;
  }, 500); // Add a small delay to show loading state
};

import { fetchTopicsAPI } from "@/api/speaking/topic";
import type { Topic } from "@/types/topic/topic";
const topics = ref<Topic[]>([]);

const fetchTopics = () => {
  isLoading.value = true;
  fetchTopicsAPI(curPartId.value, curCategoryId.value).then(
    (response) => {
      topics.value = response.data;
      isLoading.value = false;
    }
  );
};

onMounted(() => {
  fetchTopics();
});

const onManageTopics = () => {
  isManagingTopic.value = !isManagingTopic.value;
  if (!isManagingTopic.value) {
    fetchTopics();
  }
};


</script>
